import { faChevronDown, faChevronUp } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { Tooltip } from '@/common/Tooltip';

interface SortControlProps {
  /** True when the list is oldest-first. */
  ascending: boolean;
  onToggle: () => void;
}

export function SortControl({ ascending, onToggle }: SortControlProps) {
  const { t } = useTranslation();

  return (
    <RightSection>
      <SortLabel>{t('wbs.sort-by-date')}</SortLabel>
      <Tooltip
        text={ascending ? t('wbs.oldest-first') : t('wbs.newest-first')}
        position="top"
      >
        <SortButton aria-label={t('wbs.sort-by-date')} onClick={onToggle}>
          <FontAwesomeIcon icon={ascending ? faChevronUp : faChevronDown} />
        </SortButton>
      </Tooltip>
    </RightSection>
  );
}

const RightSection = styled.div`
  align-items: center;
  display: flex;
  gap: 8px;
  position: relative;
  z-index: 1;
`;

const SortLabel = styled.span`
  color: var(--grey-600);
  font-family: var(--open-sans);
  font-size: 15px;
  font-weight: 300;
`;

const SortButton = styled.button`
  align-items: center;
  background: var(--white);
  border: 1px solid var(--grey-300);
  color: var(--wbs-red);
  cursor: pointer;
  display: flex;
  font-size: 10px;
  justify-content: center;
  padding: 6px 3px;
  transition: all 0.2s;
`;
